import { Component, Input, OnInit, ViewChildren, ViewChild, EventEmitter, Output } from '@angular/core';
import { PlantingSiteDetailDto } from '../../../../models/trofaco/plantingSiteDetailDto';
import { ArrayHelper } from '../../../../models/helpers/array-helper';
import { CertificateDto } from 'src/app/models/trofaco/certificateDto';
import { PlantingSiteService } from 'src/app/modules/core/services/planting-site.service';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
import { ConfirmDeleteModalComponent } from 'src/app/modules/core/components/delete-modal/confirm-delete-modal-component';
import { CustomerDto } from 'src/app/models/trofaco/customerDto';
import { CreateCustomerModalComponent } from './create-customer-modal/create-customer-modal.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html'
})
export class CertificatesComponent implements OnInit {

    discardValues$ = new Subject<boolean>();
    showCustomerOnSite$ = new Subject<CertificateDto>();

    get selectedCustomer(): string {
        return this._selectedCustomer;
    }

    get certificates(): CertificateDto[] {
        return this._certificates;
    }

    @Input()
    set certificates(value: CertificateDto[]) {
        this._certificates = value;
        this.sortCollectionByCode();
    }

    @Output()
    certificatesChange = new EventEmitter<CertificateDto[]>();

    @Input()
    customers: CustomerDto[];

    get totalAvailableTrees(): number {
        return this.site.totalTrees - this.sumAllOfTrees;
    }

    newCustomer: CustomerDto;
    sumAllOfTrees: number;
    misc: number;

    @Input()
    site: PlantingSiteDetailDto = {
            id: '',
            certificates: [],
            partners: [],
            species: [],
            areas: [],
            collections: []
    };

    private _certificates: CertificateDto[] = [];
    private _selectedCustomer: string;
    private readonly confirmDeleteMsg = "Are you sure you want to delete";

    editingCertificates?: CertificateDto;
    deletingCertificates?: CertificateDto;

    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];
    @ViewChild(ConfirmDeleteModalComponent, { static: false }) confirmDeleteModal: ConfirmDeleteModalComponent;
    @ViewChild(NgForm, { static: true }) form: NgForm;

    constructor( private plantingSiteService: PlantingSiteService ) {
    }

    ngOnInit() {
        this.calculateTotalAmount();
    }

    async save(newcertificate: CertificateDto) {
        this.certificates.push(newcertificate);
        this.calculateTotalAmount();
        this.sortCollectionByCode();
        this.certificatesChange.emit(this._certificates);
        await this.plantingSiteService.getById(this.site.id).then(site => {
            this.site = site;
        });
    }

    async updateCertificates(cert: CertificateDto) {
        this._certificates = [cert, ...this._certificates.filter(value => value.id != cert.id)];
        this._certificates = ArrayHelper.sortBy(this._certificates, true, coll => coll.code);
        this.calculateTotalAmount();
        this.sortCollectionByCode();
        this.certificatesChange.emit(this._certificates);
        await this.plantingSiteService.getById(this.site.id).then(site => {
            this.site = site;
        });
        return cert.id;

    }

    async delete(cert: CertificateDto) {
        let result = await this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
        if (result) {
            let id = await this.plantingSiteService.deletCertificate(cert.id);
            this._certificates = this._certificates.filter(x=> x.id != id);
            this.calculateTotalAmount();
            this.sortCollectionByCode();
            this.certificatesChange.emit(this._certificates);
            await this.plantingSiteService.getById(this.site.id).then(site => {
                this.site = site;
            });
        }
    }


    @Input()
    countries: string[];

    @ViewChild(CreateCustomerModalComponent, { static: false }) createCustomerModal: CreateCustomerModalComponent;
    showCustomer() {
        this.createCustomerModal.show();
    }

    calculateTotalAmount() {
        if (this._certificates === undefined) return false;

        this.sumAllOfTrees = this._certificates.reduce((sum, current) => sum + +current.count, 0);

        this.misc = this.site.totalTrees - this.sumAllOfTrees;

    }

    updateCustomer(customer: CustomerDto) {
        this.customers.push(customer);
        this.newCustomer = customer;
    }

    sortCollectionByCode() {
        this._certificates = ArrayHelper.sortBy(this._certificates, false, cert => cert.code);
    }
}
